import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCircleMinus } from '@fortawesome/pro-regular-svg-icons';
import { Card, Button } from '@platzi/ui';
import styles from './FollowModal.module.sass';

export const FollowModal = (props) => {
  const { t } = useTranslation();

  if (!props.showModal) return null;

  return (
    <div className={styles.Modal} data-testid="modal">
      <Card isDark customClass={styles.Card}>
        <button
          className={styles.CloseModal}
          type="button"
          onClick={() => props.closeModal(false)}
          aria-label={t('escuela.share.buttonCloseModal')}
        >
          <FontAwesomeIcon icon={faTimes} size="sm" />
        </button>
        <div>
          <div className={styles.CardHead}>
            <span>
              <FontAwesomeIcon icon={faCircleMinus} />
            </span>
            <p>{t('escuela.followModal.title')}</p>
          </div>
          <p className={styles.CardCopy}>{t('escuela.followModal.copy')}</p>
          <div className={styles.CardFooter}>
            <Button customClass={styles.CardCancelar} onClick={() => props.closeModal(false)}>
              {t('escuela.followModal.buttonCancel')}
            </Button>
            <Button onClick={props.unfollow}>{t('escuela.followModal.buttonConfirm')}</Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
